// extracted by css-extract-rspack-plugin
export default {"tag_button":"vBpHa","tagButton":"vBpHa","tag_count":"IYjl0","tagCount":"IYjl0"};